import React from "react";
import {
  Box,
  CardContent,
  TableCell,
  TableRow,
  styled,
  tableCellClasses,
  Card,
  IconButton,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import MoreVertIcon from "@mui/icons-material/MoreVert";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    border: "1px solid var(--border-color)",
    color: "var(--text-primary)",
    padding: "6px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
    color: "var(--text-primary)",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme, isExpandable }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: isExpandable ? "var(--bg-highlight)" : "var(--row-bg-odd)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: isExpandable
      ? "var(--bg-highlight)"
      : "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },

  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ClientMobileCard = ({
  data,
  handleMenuOpen,
  handleStatusToggle,
  ListItem,
  IOSSwitch,
  ActionButtons,
  menuPosition,
  menuRef,
  Action,
  setSelectedClient,
  setTms,
  setWms,
  setOpenProviderModal,
}) => {
  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_client.png"
        alt="No data available"
        style={{ objectFit: "cover", height: "300px" }}
      />
    </div>
  );
  return (
    <Box sx={{ width: "100%", padding: 0.5 }}>
      {data.length === 0 ? (
        <NoDataImage />
      ) : (
        data?.map((client, index) => (
          <Card
            key={index}
            sx={{
              marginBottom: 2,
              backgroundColor: "var(--bg-paper)",
              borderRadius: 4,
            }}
          >
            <CardContent>
              <div
                style={{
                  display: "flex",
                  padding: 10,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <ListItem
                    value={`: ${client.business_name || client.name}`}
                    header={"Name"}
                  ></ListItem>
                  <ListItem
                    value={`: ${client.contact}`}
                    header={"Mobile No"}
                  ></ListItem>
                  <ListItem
                    value={`: ${client.email}`}
                    header={"Email"}
                  ></ListItem>
                  <ListItem
                    value={
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          maxWidth: 120,
                        }}
                      >
                        <CustomTypography
                          style={{ marginRight: 2, minWidth: 50 }}
                          fontSize="13px"
                          color={
                            client?.status === "Rejected"
                              ? "red"
                              : client?.status === "Active"
                                ? "#007D14"
                                : client?.status === "Pending"
                                  ? "#FF8A00"
                                  : client?.status === "Approved"
                                    ? "#FF8A00"
                                    : "#757477"
                          }
                          fontWeight={500}
                        >
                          : {client.status}
                        </CustomTypography>
                        {client.status === "Rejected" ? (
                          <></>
                        ) : (
                          <div
                            onClick={(e) => {
                              if (
                                !["Pending", "Uninstalled"].includes(
                                  client.status,
                                )
                              ) {
                                e.preventDefault();
                                e.stopPropagation();
                                handleStatusToggle(
                                  client._id,
                                  client.status,
                                  e,
                                  client.email,
                                );
                              }
                            }}
                            style={{
                              pointerEvents: [
                                "Pending",
                                "Uninstalled",
                              ].includes(client.status)
                                ? "none"
                                : "auto",
                              opacity: ["Pending", "Uninstalled"].includes(
                                client.status,
                              )
                                ? 0.5
                                : 1,
                            }}
                          >
                            {client.status === "Uninstalled" ? (
                              <></>
                            ) : (
                              <IOSSwitch
                                disabled={["Pending"].includes(client.status)}
                                checked={client.status == "Active"}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    }
                    header={"Status"}
                  ></ListItem>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <ActionButtons
                  index={index}
                  gridView={true}
                  view
                  client={client}
                  setSelectedClient={setSelectedClient}
                  setTms={setTms}
                  setWms={setWms}
                  setOpenProviderModal={setOpenProviderModal}
                ></ActionButtons>
                <IconButton
                  aria-haspopup="true"
                  onClick={(e) => handleMenuOpen(e, client)}
                >
                  <MoreVertIcon />
                </IconButton>
              </div>
            </CardContent>
          </Card>
        ))
      )}
      {menuPosition && (
        <div
          ref={menuRef}
          style={{
            position: "absolute",
            top: menuPosition.y,
            left: menuPosition.x - 20,
            backgroundColor: "var(--bg-paper)",
            border: "1px solid var(--border-color)",
            borderRadius: "8px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            width: "200px",
          }}
        >
          <Action></Action>
        </div>
      )}
    </Box>
  );
};

export default ClientMobileCard;
